import { render } from "./CatalogEdit.vue?vue&type=template&id=f126282c&scoped=true"
import script from "./CatalogEdit.vue?vue&type=script&lang=js"
export * from "./CatalogEdit.vue?vue&type=script&lang=js"

import "./CatalogEdit.vue?vue&type=style&index=0&id=f126282c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-f126282c"

export default script